import { Component, OnInit, ViewChild } from '@angular/core';
import { Contacts } from '../models/contacts.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, catchError, filter } from 'rxjs/operators';
import { of } from 'rxjs';
import {  IServerSideDatasource, IServerSideGetRowsParams, ICellRendererParams, IServerSideGetRowsRequest, RowNode, GridApi, GridOptions, CellEditingStoppedEvent } from 'ag-grid-community';
import { AgGridAngular } from 'ag-grid-angular';
import { RowDragMoveEvent, RowDragEndEvent, StateUpdatedEvent } from 'ag-grid-community';
import { ContactDetailsComponent } from './contact-details/contact-details.component'
import { TmplAstVariable } from '@angular/compiler';
import { ContactTypeEditorComponent } from './contact-type-editor/contact-type-editor.component'
import { ActivatedRoute, Router} from '@angular/router';
import { UserGridStateService } from '../user-grid-state.service';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss']
})
export class ContactsComponent implements OnInit {
  @ViewChild('agGrid', { static: false }) agGrid!: AgGridAngular;
  // assign Contact Details component to be the detail cell rendered upon expanding a row
  public detailCellRenderer: any = ContactDetailsComponent;

  // set detail row auto height to true, have to ask for support since not working
  detailRowAutoHeight = true;
  isCustomDetailsOpen = false;

  // set initial static height for the detail grid
  detailRowHeight = 650;

  // headers/columns for main contacts grid
  columnDefs = [
    {
      field: 'contact_uuid',
      headerName: 'Contact UUID',
      hide: true,
      editable: false,
    },
    {
      headerName: '', 
      cellRenderer: (params: any) => {
        const button = document.createElement('button');
        button.title = 'Open Contact details';
        button.innerHTML = '<i class="fa-solid fa-up-right-from-square" aria-hidden="true"></i>';

        button.addEventListener('click', () => {
            this.contactDetails(params);
        });
        return button;        
      }, 
      details: false, 
      width: 120, 
      filter: false,
      sortable: false,
    },    
    {
      field: 'contact_organization',
      headerName: 'Contact Organization',
      cellRenderer: 'agGroupCellRenderer'
    },
    {
      field: 'contact_types',
      headerName: 'Contact Type',
      cellRenderer: contactTypeFormatting,
      cellEditor: ContactTypeEditorComponent,
      cellEditorPopup: true,
      cellEditorParams: {
        multiple: true,
        types: [
          "Default",
          "Manufacturer",
          "Service Provider",
          "Contractor",
          "Shipper",
          "Receiver Consignee",
          "Carrier",
          "Payment Processor",
          "Vendor",
          "Reseller",
          "Distributor",
          "Agent",
          "Friend",
          "Family",
          "Volunteer",
          "Company Division",
          "Driver",
          "APP Client",
          "Logistics Broker",
          "Customs Broker",
          "Customer Bill To",
          "Insurance Agent",
          "Prospect",
          "Hot Prospect",
          "Representative",
          "Business Reference",
          "Warehouse Terminal",
          "Technician"
        ]
      },
      filter: 'agSetColumnFilter',
      filterParams: {
        values: [ 
          "Default",
          "Manufacturer",
          "Service Provider",
          "Contractor",
          "Shipper",
          "Receiver Consignee",
          "Carrier",
          "Payment Processor",
          "Vendor",
          "Reseller",
          "Distributor",
          "Agent",
          "Friend",
          "Family",
          "Volunteer",
          "Company Division",
          "Driver",
          "APP Client",
          "Logistics Broker",
          "Customs Broker",
          "Customer Bill To",
          "Insurance Agent",
          "Prospect",
          "Hot Prospect",
          "Representative",
          "Business Reference",
          "Warehouse Terminal",
          "Technician"
        ]
      },
    },
    {
      field: 'contact_name_given',
      headerName: 'First Name',
      editable: true
    },
    {
      field: 'contact_name_family',
      headerName: 'Last Name'
    },
    {
      field: 'phone_number',
      headerName: 'Phone Number',
      editable: true
    },
    {
      field: 'address_street',
      headerName: 'Address Street',
      editable: true
    },
    {
      field: 'address_extended',
      headerName: 'Address Extended'
    },
    {
      field: 'address_community',
      headerName: 'Community'
    },
    {
      field: 'address_locality',
      headerName: 'City'
    },
    {
      field: 'address_region',
      headerName: 'State/Province'
    },
    {
      field: 'address_postal_code',
      headerName: 'Postal Code'
    },
    {
      field: 'address_country',
      headerName: 'Country'
    },

  ]

  // default column definitions
  defaultColDef = {
    sortable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      caseSensitive: false,
      buttons: ['apply', 'clear', 'reset']
    },
    autoHeight: true,
    cellClass: 'cell-wrap-text',
    resizable: true,
    editable: true
  };

  rowData: Contacts[] = [];

  // ngAfterViewInit() {
  //   if (this.agGrid) {
  //     this.route.queryParams.subscribe((params) => {
  //       const filterText = params['filterName'];
  //       const filterType = params['filterType']
  //       if (filterText && filterType) {
  //         this.applyNameFilter(filterText, filterType);
  //       }
  //       else {
  //         console.log('no valid record')
  //       }
  //     });
  //   }
  // }

  // applyNameFilter(filterText: string, filterType: string) {
  //   if (this.agGrid) {
  //     this.agGrid.api.setFilterModel({
  //       contact_organization: {
  //         filterType: "text",
  //         type: "equals",
  //         filter: filterText,
  //       },
  //       contact_types: {
  //         filterType: "text",
  //         type: "equals",
  //         filter: filterType,
  //       },
  //     });
  //     this.agGrid.api?.onFilterChanged();
  //   }

  // }

  // attempt at making the contact detail a dynamic height
  gridOptions: GridOptions = {
    getRowHeight: (params) => {
      if (params.node && params.node.detail) {
        // if dynamic return the the dynamic height for rows
        return params.node.data.dynamicContentHeight;
      }
      // just return default height for other rows
      // return this.rowHeight;
    }
  }

  constructor(private http: HttpClient, private route: ActivatedRoute, private router: Router, private gridStateService: UserGridStateService) {
    // communicate with contact-details component (detail cell renderer)
    this.gridOptions = <GridOptions>{
      context: {
        componentParent: this
      }
    }
  }

  // update grid state table if column size or column order changes
  onStateUpdated(params: StateUpdatedEvent<Contacts>): void {
    // if(params.sources.indexOf('columnSizing') > -1 || params.sources.indexOf('columnOrder') > -1){
    //   this.gridStateService.saveUserGridState('contacts',params.state);
    // }
  }

  ngOnInit() {
  }

  private gridApi!: GridApi;

  onGridReady(params: any) {
    this.gridApi = params.api
    params.api.setGridOption("serverSideDatasource", this.getServerSideDatasource());
    this.gridApi = params.api;
    // // Resize columns to fit the grid width
    this.gridApi?.addEventListener('firstDataRendered', () => {
      this.autoSizeAll(false);
    });

  }

  // auto size the columns in the ag-grid
  autoSizeAll(skipHeader: boolean) {
    const allColumnIds: string[] = [];
    this.gridApi.getColumns()!.forEach((column) => {
      allColumnIds.push(column.getId());
    });
    this.gridApi.autoSizeColumns(allColumnIds, skipHeader);
  }

  // allows editing of columns, updates cells upon exiting out of the cell
  onCellEditingStopped(event: CellEditingStoppedEvent) {

    // grab the value being edited, column, and row
    const editedValue = event.value;
    const column = event.column;
    const rowNode = event.node;

    // grab UUIDs from the contact profile outline to send to appropriate API calls
    const uuid = rowNode.data.contact_uuid;
    const phone_uuid = rowNode.data.contact_phone_uuid;
    const address_uuid = rowNode.data.contact_address_uuid;

    // create URLS to send POST data to
    const url = '/api/contacts/contacts.php'
    const contact_phone_url = `/api/contacts/contact_phones.php?uuid=${phone_uuid}`;
    const contact_address_url = `/api/contacts/contact_addresses.php?uuid=${address_uuid}`;
    const columnName = column.getColId();

    var postData = {}

    // if an edit is made in the phone number column table
    if (columnName === 'phone_number') {
      // GET request to the contact profile API call for specific contact_UUID
      postData = {
        contact_phone_uuid: phone_uuid,
        [columnName]: editedValue
      }

      return this.http.post<any>(contact_phone_url, postData)
        .subscribe(response => {
          console.log('Post Response: ', response)
        })

      // if an edit is made in one of the address columns
    } else if (columnName === 'address_street' ||
      columnName === 'address_extended' ||
      columnName === 'address_region' ||
      columnName === 'address_postal_code' ||
      columnName === 'address_community' ||
      columnName === 'address_country' ||
      columnName === 'address_locality') {
      postData = {
        contact_address_uuid: address_uuid,
        [columnName]: editedValue
      }

      return this.http.post<any>(contact_address_url, postData)
        .subscribe(response => {
          console.log('Post Response: ', response)
        })

      // if an edit is made in the contact types column
    } else if (columnName === 'contact_types') {
      return
      // if an edit is made in any other column
    } else {
      postData = {
        contact_uuid: uuid,
        [columnName]: editedValue
      }

      return this.http.post<any>(url, postData)
        .subscribe(response => {
          console.log('Post Response: ', response)
        })

    }
  }


  contactDetails(params: any) {
    const contact_uuid = params.data.contact_uuid;
    this.router.navigate(['contact_full_details', contact_uuid],);
  }

  // retrieve contacts data from API and set the filters/sorting model
  getServerSideDatasource(): IServerSideDatasource {
    return {
      getRows: (params: IServerSideGetRowsParams) => {
        this.getContacts(params.request.startRow, params.request.endRow, params.request.filterModel, params.request.sortModel)
          .subscribe(
            response => {
              if (response) {
                params.success({ rowData: response.rowData, rowCount: response.rowCount });
              } else {
                params.fail();
              }
            },
            error => {
              console.log(error);
              params.fail();
            }
          );
      }
    };
  }

  getContacts(startRow: number = 0, endRow: number = 0, filterModel: any = {}, sortModel: any = []) {
    const url = '/api/contacts/contacts.php';

    // const filters = Object.entries(filterModel).map(([column, filter]: [string, any]) => {
    //   return {
    //     column,
    //     operator: filter.type === 'contains' ? 'ILIKE' : '=',
    //     value: filter.type === 'contains' ? `%${filter.filter}%` : filter.filter,
    //   };
    // });

    const filtered_contact_uuid = this.route.snapshot.queryParamMap.get('contact_uuid');


    const filters = Object.entries(filterModel).map(([column, filter]: [string, any]) => {
      let operator = '';
      let value = '';

      console.log('Filter model:', filterModel);
      console.log('Filter:', filter)
      console.log('Filter Type:',filter.type)

      if (filter.filterType === 'text') {
        operator = filter.type;
        value = filter.filter;
      } else if (filter.filterType === 'set') {
        operator = 'equals'; // Or any other appropriate operator for set filter
        value = filter.values.join(','); // Join selected values with a delimiter if needed
      }
      return {
        column,
        operator,
        value,
      };
    });

    if (filtered_contact_uuid) {
      filters.push({
        column: 'contacts-contact_uuid',
        operator: 'equals',
        value: filtered_contact_uuid,
      });
    }

    const params: any = {
      startRow: startRow,
      endRow: endRow,
      sortModel: JSON.stringify(sortModel),
      filters: JSON.stringify(filters),
    };

    return this.http.get<any>(url, { params }).pipe(
      map((response) => {
        console.log('API response:', response);
        const rowData = response.data.map((contactsData: any) => {
          const contacts = new Contacts();
          Object.assign(contacts, contactsData);
          return contacts;
        });

        return {
          rowData: rowData,
          rowCount: response.total,
        };
      }),
      catchError((error) => {
        console.log(error);
        return of(null);
      }),
      filter(response => response !== null)
    );
  }
}

// function for custom cell renderer for contact types (colored)
function contactTypeFormatting(params: ICellRendererParams) {
  let contactTypes: string[] = []
  if (params.value != null) {
    contactTypes = params.value.split(",");
  }
  let buttonsHtml = '';

  for (let type of contactTypes) {
    let trimmedType = type.trim();
    let bgColor = '';

    switch (trimmedType) {
      case 'Payment Processor':
        bgColor = '#52da6f';
        break;
      case 'Receiver Consignee':
        bgColor = '#Ff98a4';
        break;
      case 'Shipper':
        bgColor = '#D3e426';
        break;
      case 'Customer Bill To':
        bgColor = '#2ab546';
        break;
      case 'Carrier':
        bgColor = '#87a3d4';
        break;
      case 'Service Provider':
        bgColor = '#Dad9be';
        break;
      case 'Distributor':
        bgColor = '#A68c69';
        break;
      case 'Insurance Agent':
        bgColor = '#Ecb44e';
        break;
      case 'Friend':
        bgColor = '#9df5b8';
        break;
      case 'Driver':
        bgColor = '#43badc';
        break;
      case 'APP Client':
        bgColor = '#81d2e8';
        break;
      case 'Customs Broker':
        bgColor = '#E98eea';
        break;
      case 'Prospect':
        bgColor = '#C7b4de';
        break;
      case 'Business Reference':
        bgColor = '#B4b4e6';
        break;
      case 'Hot Prospect':
        bgColor = '#E42697';
        break;
      case 'Manufacturer':
        bgColor = '#E8c87c';
        break;
      case 'Contractor':
        bgColor = '#D247b1';
        break;
      case 'Representative':
        bgColor = '#Aa87f9';
        break;
      case 'Warehouse Terminal':
        bgColor = '#F10819';
        break;
      case 'Technician':
        bgColor = '#F1ff09';
        break;              
      case 'Family':
        bgColor = '#7cf3a2';
        break;
      case 'Agent':
        bgColor = '#F9c32d';
        break;
      case 'Reseller':
        bgColor = '#B037f9';
        break;
      case 'Vendor':
        bgColor = '#F1f964';
        break;
      case 'Logistics Broker':
        bgColor = '#52aff9';
        break;
      case 'Company Division':
        bgColor = '#E0a2ac';
        break;
      case 'Volunteer':
        bgColor = '#Ddec95';
        break;
      default:
        bgColor = '#FFFFFF';
    }

    buttonsHtml += '<button class="btn dropdown-toggle button-text-wrapper" style="background-color:' + bgColor + ';border-radius:10px;font-weight:bold;">' + trimmedType + '</button> <br>';
  }

  let element = '<div class="btn-group">' + buttonsHtml + '</div>';

  return element;
}



